import { useContext } from 'react'
import idv4 from 'uuid/v4'
import { db } from '../config/firebase'
import firebase from 'firebase'
import { store } from '../store'

export const FireAddPassword = () => {
    return (url, username, password, user) => {
        return db.collection('account').doc(user).update({
            collections: 
            firebase.firestore.FieldValue.arrayUnion({
                id: idv4(),
                url,
                username,
                password,
                createdAt: Date.now()
            })
        })
    }
}

export const FireUpdatePass = () => {
    return (updatefix, user) => {
        return db.collection('account').doc(user).update({ 
            collections : updatefix
        })
    }
}

export const FireRemovePass = () => {
    return (data, user) => {
        return db.collection('account').doc(user).update({ 
            collections : data
        })
    }
}

export const FireFetchData = () => {
    const { dispatch } = useContext(store)
    return (user) => {
        db.collection('account')
            .doc(user)
            .onSnapshot(doc => {
                dispatch({
                    type: 'PASS_LIST_REFRESH',
                    listPass: doc.data().collections
                })
                dispatch({
                    type: "PASSLIST_LOADING",
                    status: false
                })
            })
    }
}